

















































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import moment from 'moment';

@Component
export default class DateComponent extends Vue {

    @Prop() model!: any; 
    @Prop() label!: string;
    @Prop() format!: string;
    @Prop() readonly!: string;
    @Prop() weekStartsAt!: string;
    @Prop() minDate: any;
    @Prop() maxDate: any;
    @Prop() appendIcon: string;
    @Prop() formOptions: any;
    @Prop() clearable: any;

    menu: boolean = false;  
    
    get dateValue() {
        return this.model;
    }

    set dateValue(newValue) {
        this.$emit("update", newValue) ;
    }

    get dateFormat() {
      return this.format || 'DD/MM/YYYY';
    }

    formattedDate(date) {
      return date ? moment(date).format(this.dateFormat) : "";
    }
}
